import ApiService from '@/core/services/api.service';

const resource = 'v1/approvals';

export default {
  /**
   * Fetch approvals with pagination and filtering
   * @param {Object} params - Filter parameters
   * @returns {Promise} - Promise with the response data
   */
  async fetchApprovals(params = {}) {
    try {
      const response = await ApiService.query(resource, { params });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching approvals:', error);
      throw error;
    }
  },

  /**
   * Delete an approval
   * @param {string|number} id - Approval ID
   * @returns {Promise} - Promise with the response data
   */
  async deleteApproval(id) {
    try {
      const response = await ApiService.delete(`${resource}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting approval:', error);
      throw error;
    }
  },

  /**
   * Return an approval request
   * @param {string|number} id - Approval ID
   * @returns {Promise} - Promise with the response data
   */
  async returnApproval(id) {
    try {
      const response = await ApiService.put(`${resource}/${id}/return`);
      return response.data;
    } catch (error) {
      console.error('Error returning approval:', error);
      throw error;
    }
  },

  /**
   * Approve an approval request
   * @param {string|number} id - Approval ID
   * @param {Object} data - Approval data
   * @returns {Promise} - Promise with the response data
   */
  async approveApproval(id, data) {
    try {
      const response = await ApiService.put(`${resource}/${id}/approve`, data);
      return response.data;
    } catch (error) {
      console.error('Error approving approval:', error);
      throw error;
    }
  },

  /**
   * Change approval status
   * @param {string|number} id - Approval ID
   * @param {Object} data - Status change data
   * @returns {Promise} - Promise with the response data
   */
  async changeApprovalStatus(id, data) {
    try {
      const response = await ApiService.put(
        `${resource}/${id}/change-status`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error('Error changing approval status:', error);
      throw error;
    }
  },
};
